import React from "react";
import styled, { useTheme } from "styled-components";
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { formatarMoeda } from "../../../utils/calculos";
import { usePrecosVisiveis } from "../../../context/PrecosContext";
import {
  ChartWrapper,
  StackedCard,
  StackedLabel,
  StackedSub,
  StackedValue,
} from "./styles";

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 200px), 1fr));
  gap: 12px;
`;

function moeda(valor, mostrar) {
  return mostrar ? formatarMoeda(valor) : "••••••";
}

function pct(value) {
  if (value == null || !Number.isFinite(value)) return "—";
  return `${(value * 100).toFixed(1)}%`;
}

function Sparkline({ data, dataKey, accent }) {
  if (!data || data.length === 0) return null;
  return (
    <ChartWrapper>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 4, right: 4, bottom: 0, left: 0 }}>
          <defs>
            <linearGradient id="adv-grad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={accent} stopOpacity={0.45} />
              <stop offset="100%" stopColor={accent} stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <Tooltip
            cursor={false}
            contentStyle={{
              fontSize: 12,
              borderRadius: 8,
            }}
            labelFormatter={(_, payload) => payload?.[0]?.payload?.label || ""}
            formatter={(value) => [formatarMoeda(value), "Ganho"]}
          />
          <Area
            type="monotone"
            dataKey={dataKey}
            stroke={accent}
            fill="url(#adv-grad)"
            strokeWidth={2}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </ChartWrapper>
  );
}

export default function AdvancedIndicators({ contabil, throughput, historicoT }) {
  const { precosVisiveis } = usePrecosVisiveis();
  const theme = useTheme();
  return (
    <Grid>
      <StackedCard>
        <StackedLabel>T · Ganho do mês</StackedLabel>
        <StackedValue>{moeda(contabil.T, precosVisiveis)}</StackedValue>
        <StackedSub>{contabil.labels.T}</StackedSub>
        <Sparkline data={historicoT} dataKey="ganho" accent={theme.accent} />
      </StackedCard>
      <StackedCard>
        <StackedLabel>I · Estoque em processo</StackedLabel>
        <StackedValue>{moeda(contabil.I, precosVisiveis)}</StackedValue>
        <StackedSub>{contabil.labels.I}</StackedSub>
      </StackedCard>
      <StackedCard>
        <StackedLabel>OE · Despesa Operacional</StackedLabel>
        <StackedValue>{moeda(contabil.OE, precosVisiveis)}</StackedValue>
        <StackedSub>{contabil.labels.OE}</StackedSub>
      </StackedCard>
      <StackedCard $tone={contabil.lucro >= 0 ? "success" : "danger"}>
        <StackedLabel>Lucro · T − OE</StackedLabel>
        <StackedValue>{moeda(contabil.lucro, precosVisiveis)}</StackedValue>
        <StackedSub>{contabil.labels.lucro}</StackedSub>
      </StackedCard>
      <StackedCard>
        <StackedLabel>ROI · Lucro ÷ I</StackedLabel>
        <StackedValue>{pct(contabil.ROI)}</StackedValue>
        <StackedSub>{contabil.labels.ROI}</StackedSub>
      </StackedCard>
    </Grid>
  );
}
